import React from 'react';
import './App.css';

import LandingPage from './pages/landingPage/Index';
// import TermsAndConditions from './pages/termsAndConditions/Index';
// import CancellationAndRefund from './pages/cancellationAndRefund/Index';
// import ContactUs from './pages/contactUs/Index';
// import PrivacyAndPolicy from './pages/privacyAndPolicy/Index';
import PrivacyPage from './pages/policy/Privacy';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import TermsAndConditionsPage from './pages/termsAndConditions/TermsAndConditions';
import CancellationAndRefundPage from './pages/cancellationAndRefund/CancellationAndRefund';
import Header from './components/header/Index';
import FooterPage from './components/Footer/footer';
import CupcakePage from './components/cupcake/cupcake'; // Note the renaming here
import AccountDeletionInstructions from './pages/accountDeletionInstructions/accountDeletionInstructions';
import Personalized from './pages/personalized/Index';

function AppWrapper() {
	const location = useLocation();
	// List of routes where Header and Footer should be hidden
	const hideLayoutRoutes = ['/personalized'];
	const shouldHideLayout = hideLayoutRoutes.includes(location.pathname);
	return (
		<>
			{!shouldHideLayout && <Header />}
			<Routes>
				<Route path="/" element={<LandingPage />} />
				<Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
				<Route path="/cancellation-and-refund" element={<CancellationAndRefundPage />} />
				<Route path="/privacy-and-policy" element={<PrivacyPage />} />
				<Route path="/account-Deletion-Instructions" element={<AccountDeletionInstructions />} />
				<Route path="/cupcake" element={<CupcakePage />} />
				<Route path="/personalized" element={<Personalized />} />
			</Routes>
			{!shouldHideLayout && <FooterPage />}
		</>
	);
}

function App() {
	return (
		<BrowserRouter>
			<AppWrapper />
		</BrowserRouter>
	);
}

export default App;
